import React from 'react'
import { connect } from 'react-redux'

import { TextField } from 'discada/dist/Form'
import Button from 'discada/dist/Button'

import draiver from 'static/images/draiverLogo.png'
import dealerPolicy from 'static/images/dpLogo.png'
import gtm from 'static/images/gtmLogo.png'
import facebook from 'static/images/facebookLogo.png'
import tp from 'static/images/tpLogo.png'
import mDesking from 'static/images/mdeskingLogo.jpeg'
import homenet from 'static/images/homenetLogo.png'

import './Integrations.scss'

export function IntegrationBlock({ logo, title, children }) {
  return (
    <div className="integration-block">
      <img className="integration-logo" src={logo} alt={title} />
      <div className="integration-body">
        <div className="integration-title">
          <h4>{title}</h4>
        </div>
        <div className="integration-description">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </div>
        <div className="integration-controls">{children}</div>
      </div>
    </div>
  )
}

export class IntegrationSettings extends React.Component {
  state = { config: {} }

  render() {
    let simpleOnChange = key => ({ target }) => {
      this.setState({ [key]: target.value })
    }

    return (
      <div className="integration-settings">
        <h1>Available Integrations</h1>

        <article className="message is-info is-small">
          <div className="message-body">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          </div>
        </article>

        <div className="integration-blocks">
          <IntegrationBlock logo={mDesking} title="mDesking">
            <TextField
              size="small"
              label="mDesking API Key"
              disabled
              onChange={simpleOnChange('mDeskingKey')}
              value={this.state.mDeskingKey}
            />
          </IntegrationBlock>
          <IntegrationBlock logo={homenet} title="Homenet">
            <TextField
              size="small"
              label="Homenet Key"
              disabled
              onChange={simpleOnChange('homenetKey')}
              value={this.state.homenetKey}
            />
          </IntegrationBlock>
          <IntegrationBlock logo={tp} title="TradePending">
            <TextField
              size="small"
              label="TradePending Website URL"
              onChange={simpleOnChange('tradePendingUrl')}
              value={this.state.tradePendingUrl}
            />
          </IntegrationBlock>
          <IntegrationBlock logo={dealerPolicy} title="Dealer Policy">
            <TextField
              size="small"
              label="Dealer Policy Key"
              onChange={simpleOnChange('dealerPolicyId')}
              value={this.state.dealerPolicyId}
            />
          </IntegrationBlock>
          <IntegrationBlock logo={draiver} title="Draiver">
            <TextField
              size="small"
              label="Draiver Key"
              onChange={simpleOnChange('draiverId')}
              value={this.state.draiverId}
            />
          </IntegrationBlock>
          <IntegrationBlock logo={gtm} title="Google Tag Manager">
            <TextField
              size="small"
              label="Tag Manager Id"
              onChange={simpleOnChange('gtmId')}
              value={this.state.gtmId}
            />
          </IntegrationBlock>
          <IntegrationBlock logo={facebook} title="Facebook Pixel">
            <TextField
              size="small"
              label="Pixel Id"
              onChange={simpleOnChange('gtmId')}
              value={this.state.facebookPixelId}
            />
          </IntegrationBlock>
        </div>

        <div className="submit-set">
          <Button icon="save" success>
            Save
          </Button>
          <Button text>Cancel</Button>
        </div>
      </div>
    )
  }
}

function mapStateToProps(_, op) {
  return { ...op }
}

export default connect(mapStateToProps)(IntegrationSettings)
